<template>
  <div class="header clearfix">
    <nav class="navbar" href="#/">
      <a class="navbar-brand">
        <img :src="defLogo" v-if="!tenant.appLogo"/>
        <img :src="tenant.appLogo" v-if="tenant.appLogo"/>
        <span class="text-muted"  v-if="isLoggedIn">{{tenant.appName || 'GST EWaybill'}}
          <span v-if="!tenant.appLogo"> - {{tenant.name}}</span>
        </span>
        <span v-if="!isLoggedIn">Login</span>
      </a>
      <div class="">
        <ul class="nav nav-pills" v-if="isLoggedIn">
          <li class="nav-item">
            <router-link class="nav-link" exact-active-class="active" to="/">Dashboard</router-link>
          </li>

          <li class="nav-item" v-if="ewbTenant">
            <router-link class="nav-link" active-class="active" to="/generate">Generate</router-link>
          </li>
          <li class="nav-item" v-if="podTenant">
            <router-link class="nav-link" active-class="active" to="/manage-pod">Manage POD</router-link>
          </li>
          <b-dropdown v-if="podTenant && !isTransporter && !isCustomer" text="Transporter Portals" variant="link">
            <b-dropdown-item v-for="t of transporters" :key="t.id" :href="t.trackingPage" target="_blank" v-if="t.trackingPage">{{t.name}}</b-dropdown-item>
          </b-dropdown>

          <b-dropdown text="EWaybill" variant="link" v-if="ewbTenant">
            <b-dropdown-item to="/reports">Reports</b-dropdown-item>
            <b-dropdown-item to="/reconciliation">Reconciliation</b-dropdown-item>
            <b-dropdown-item to="/validate">Validate GSTIN</b-dropdown-item>
          </b-dropdown>

          <li class="nav-item" v-if="isAdminLoggedIn && !isCustomer">
            <router-link class="nav-link" active-class="active" to="/admin">Admin</router-link>
          </li>
          <li class="nav-item" v-if="isLocalAdmin">
            <router-link class="nav-link" active-class="active" to="/users">Admin</router-link>
          </li>

          <b-dropdown text="Help" variant="link" v-if="!isCustomer">
            <b-dropdown-item v-if="isTransporter || isLocalAdmin || isAdminLoggedIn" href="https://docs.google.com/document/d/1pVkjtSwqZ4nP7WfVRQ6AT5Sbzn0lhJC7RVNC32dCjo0/edit?usp=sharing" target="_blank">Transporter User Manual</b-dropdown-item>
            <b-dropdown-item v-if="isLocalAdmin || isAdminLoggedIn" href="https://docs.google.com/document/d/1kgiUL2lpPrOseBa4grFI2-_Ke3EKiQaDF-hoKq8AVac/edit?usp=sharing" target="_blank">Local Admin User Manual</b-dropdown-item>
            <b-dropdown-item v-if="isAdminLoggedIn" href="https://docs.google.com/document/d/1Tj6YY0oU2C_J4ctdvQleSsqSWLo4HEkcY3HOQsD1Ihs/edit?ts=5ce256b2#" target="_blank">Admin User Manual</b-dropdown-item>
            <b-dropdown-item v-if="!isTransporter" to="/contacts">Contact Details</b-dropdown-item>
          </b-dropdown>

          <b-dropdown :text="user.name" variant="link">
            <b-dropdown-item href="#/logout" >Logout</b-dropdown-item>
          </b-dropdown>
        </ul>
      </div>
      <span class="navbar-text ml-2" v-if="podTenant">
        Last Updated : {{lastUpdate}}
      </span>
    </nav>

  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'AppHeader',
  data () {
    return {
      lastUpdate: ''
    }
  },
  computed: {
    defLogo () {
      return process.env.DEF_LOGO
    },
    transporters () {
      return this.$store.state.transporters
    },
    isLoggedIn () {
      return this.$store.state.loggedIn
    },
    isAdminLoggedIn () {
      return this.$store.state.adminLoggedIn
    },
    isLocalAdmin () {
      return this.$store.state.localAdmin
    },
    isTransporter () {
      return this.$store.state.userType === 'TRANSPORTER'
    },
    isCustomer () {
      return this.$store.state.userType === 'CONSIGNEE'
    },
    tenant () {
      return this.$store.state.tenant
    },
    user () {
      return this.$store.state.user
    },
    ewbTenant () {
      return this.$store.state.ewbTenant
    },
    podTenant () {
      return this.$store.state.podTenant
    }
  },
  created: function () {
    this.getLastUpdate()
    setInterval(() => {
      this.getLastUpdate()
    }, 5 * 60 * 1000)
  },
  methods: {
    getLastUpdate: function () {
      if (location.hostname.indexOf('mmm.com') > -1 || location.hostname.indexOf('3m.com') > -1) {
        axios.get('/misc/last-update')
          .then(resp => {
            this.lastUpdate = resp.data.runAt
          })

        document.getElementsByTagName("title")[0].innerHTML = '3M ePOD & Logistics Tracking'
      }
    }
  }

}
</script>

<style scoped>
.navbar-brand img {
  max-height: 43px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue